import { useMemo, useState } from 'react'
import {
  TIMER_REPEAT_PROPOSAL,
  TIMER_REPEAT_PROPOSAL_TIME,
} from '~/widgets/Proposal/constants'
import { SMS_CODE_LENGTH } from '~/shared/config/constants'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { usePushCode } from '~/shared/lib/push'
import { VerificationFieldElement } from '~/shared/ui/form'
import { Modal } from '~/shared/ui/Modal'
import { RepeatCode } from '~/shared/ui/RepeatCode'
import { Description, Title } from './styled'

type CodeConfirmationModalProps = {
  isShow: boolean
  onOk: (code: string) => Promise<void>
  onCodeRepeat: () => void
}

export function CodeConfirmationModal({
  isShow,
  onOk,
  onCodeRepeat,
}: CodeConfirmationModalProps) {
  const [code, setCode] = useState<string>()

  const handleCodeChange = (code: string) => {
    setCode(code)
  }

  const { error } = usePushCode({
    onCode: handleCodeChange,
  })

  const okButtonProps = useMemo(
    () => ({
      disabled: code?.length !== SMS_CODE_LENGTH,
    }),
    [code?.length],
  )

  const handleOnOk = async () => {
    if (error) {
      snackbarEnqueued({ message: error, variant: 'danger' })
      return
    }
    await onOk(code as string)
  }

  return (
    <Modal
      isShow={isShow}
      ok='Подписать'
      onOk={handleOnOk}
      okButtonProps={okButtonProps}
    >
      <Title>Последний шаг!</Title>
      <Description>
        Введите код, который придет на ваш номер, чтобы получить полный доступ к
        приложению
      </Description>

      <VerificationFieldElement onChange={handleCodeChange} value={code} />
      <br />

      <RepeatCode
        onCodeRepeat={onCodeRepeat}
        time={TIMER_REPEAT_PROPOSAL_TIME}
        storageKey={TIMER_REPEAT_PROPOSAL}
      />
    </Modal>
  )
}
